module.exports = __webpack_public_path__ + "static/img/fdmPurpose1.5446094.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/fdmPurpose1.png
// module id = IuAL
// module chunks = 2